import { Dispatch, SetStateAction } from 'react';
import { OrderType } from '../../types';
import dayjs from '../../utils/dayjs';
import { LocalPath } from '../../routes/components/path';
import type { DeliveringRestaurantDto } from '@kotipizzagroup/kotipizza-shops-api-client';
import {
  CreateUserAddressRequest,
  UpdateUserAddressRequest,
  UserAddressDto,
} from '@kotipizzagroup/kotipizza-users-api-client';
import { SbComponentBase } from '../storyblok/types';

export type Coordinates = {
  latitude?: number;
  longitude?: number;
};

export type ShortCoordinates = {
  lat: number;
  lng: number;
};

export type AddressSelectionOrderData = {
  type: OrderType;
  userAddress: UserAddressDto | null;
  restaurantId: number | null;
  restaurant?: DeliveringRestaurantDto;
  preorder: {
    isPreOrder: boolean;
    preorderTime: dayjs.Dayjs | null;
  } | null;
};

export type ContextType = {
  orderType: OrderType;
  orderContainsAlcohol: boolean;
  inputAddress: UserAddressDto | null;
  addressBookAddressId: number | null;
  restaurantId: number | null;
  isPreorder: boolean;
  preorderTime: dayjs.Dayjs | null;
  searchQuery: string;
  userLocation: Coordinates | null;
  setAddressBookAddressId: (id: number | null) => void;
  setInputAddress: Dispatch<SetStateAction<UserAddressDto | null>>;
  setOrderType: (type: OrderType) => void;
  setRestaurantId: (restaurantId: number) => void;
  setIsPreorder: (value: boolean) => void;
  setPreorderTime: (value: dayjs.Dayjs | null) => void;
  setApartmentNumber: (apartmentNumber: string) => void;
  setSearchQuery: (query: string) => void;
  updateAddress: (address: UpdateUserAddressRequest) => Promise<void>;
  createAddress: (address: CreateUserAddressRequest) => Promise<UserAddressDto>;
  deleteAddress: (address: UserAddressDto) => Promise<void>;
  setDefaultAddress: (address: UserAddressDto) => Promise<void>;
  onRestaurantSelected?: (data: AddressSelectionOrderData) => void;
  setUserLocation: Dispatch<SetStateAction<Coordinates | null>>;
  isHomepage?: boolean;
};

export enum DeliveryCampaignType {
  FREE_DELIVERY_CAMPAIGN = 'free_delivery_campaign',
  LOCAL_FREE_DELIVERY_CAMPAIGN = 'local_free_delivery_campaign',
}

export type AddressSelectionData = SbComponentBase & {
  title: string;
  description: string;
  link_label: string;
  link?: { url?: LocalPath };
  campaign_title?: string;
  campaign_description?: string;
  campaign_start?: string;
  campaign_end?: string;
  campaign_type?: DeliveryCampaignType;
  campaign_preorder_blocked?: boolean;
  preorder_title: string;
  preorder_description: string;
  price_color: string;
};
